<template>
  <b-row>
    <b-colxx class="disable-text-selection">
      <b-row>
        <b-colxx xxs="12">
          <!-- <h1>{{ $t("menu.data-list") }}</h1> -->
          <h1><i class="simple-icon-people mr-2"></i>Les Patients</h1>
          <div class="top-right-button-container">
            <b-button @click="addItem" v-b-modal.modalright variant="primary" size="lg" class="top-right-button"
              ref="openModal">
              Ajouter
            </b-button>

            <b-modal id="modalright" ref="modalright" :title="isEdit ? 'Editer un Patient' : 'Ajouter un Patient'"
              class="modal-right">
              <b-form>
                <b-form-group :label="'Nom Complet'">
                  <b-form-input v-model="newUser.name" />
                </b-form-group>
                <b-form-group :label="'CIN'">
                  <b-form-input v-model="newUser.cin" />
                </b-form-group>
                <b-form-group :label="'Email'">
                  <b-form-input v-model="newUser.email" />
                </b-form-group>
                <b-form-group :label="'Telephone'">
                  <b-form-input v-model="newUser.phone" />
                </b-form-group>
                <b-form-group :label="'Assurance'">
                  <b-form-input v-model="newUser.mituel" />
                </b-form-group>

                <b-form-group :label="'Adresse'">
                  <b-form-input v-model="newUser.adresse" />
                </b-form-group>
                <b-form-group :label="'Genre'">
                  <!-- <b-form-input v-model="newUser.gender" /> -->
                  <b-radio name="masculin" value="masculin" class="mb-3" v-model="newUser.gender">
                    Masculin
                  </b-radio>

                  <b-radio name="féminin" value="féminin" class="mb-3" v-model="newUser.gender">
                    Féminin
                  </b-radio>
                </b-form-group>
                <b-form-group :label="'Date de Naissance'">
                  <b-form-input v-model="newUser.birthdate" />
                </b-form-group>
                <b-form-group :label="'profession'">
                  <b-form-input v-model="newUser.profession" />
                </b-form-group>
                <b-form-group :label="'Situation Familiale'">
                  <!-- <b-form-input v-model="newUser.situation" /> -->
                  <b-radio name="celibataire" value="célibataire" class="mb-3" v-model="newUser.situation">
                    Célibataire
                  </b-radio>

                  <b-radio name="marie" value="marié" class="mb-3" v-model="newUser.situation">
                    Marié
                  </b-radio>
                </b-form-group>
                <b-form-group :label="'Rabais'">
                  <b-form-input v-model="newUser.rabais" />
                </b-form-group>
                <b-form-group :label="'Antecedents'">
                  <!-- <b-form-input v-model="newUser.antecedents" /> -->
                  <textarea v-model="newUser.antecedents" class="form-control resize-none" rows="3"
                    placeholder="Allergie"></textarea>
                </b-form-group>
                <b-form-group :label="'Allergie'">
                  <textarea v-model="newUser.allergie" class="form-control resize-none" rows="3"
                    placeholder="Allergie"></textarea>
                  <!-- <b-form-input v-model="newUser.allergie" /> -->
                </b-form-group>
              </b-form>

              <template slot="modal-footer">
                <b-button variant="outline-secondary" @click="hideModal('modalright')">Annuler</b-button>
                <b-button variant="primary" @click="addNewItem()" class="mr-1">Confirmer</b-button>
              </template>
            </b-modal>
          </div>

          <div class="mb-2 mt-2">
            <b-button variant="empty" class="pt-0 pl-0 d-inline-block d-md-none" v-b-toggle.displayOptions>
              {{ $t("pages.display-options") }}
              <i class="simple-icon-arrow-down align-middle" />
            </b-button>
          </div>
          <div class="separator mb-5" />
        </b-colxx>
      </b-row>
      <template v-if="isLoad">
        <label class="form-group has-float-label" v-if="listPatients.length">
          <input placeholder="Filtrer par Nom ou CIN ou Telepohne" type="text" class="form-control"
            v-model="searchText" />
          <span>Rechercher</span>
        </label>
        <b-row v-if="displayMode === 'thumb'" key="thumb">
          <b-colxx xxs="12" class="mb-3" v-for="(item, index) in filtredPatients" :key="index" :id="item.id">
            <data-list-item :key="item.id" :data="item" @edit="editPatient($event, item.id)"
              @delete="deletePatient($event, item.id)" />
          </b-colxx>
          <b-colxx xxs="12" class="mb-3" v-if="patientsPage">
            <b-button v-if="!loadingMore" @click="getMorePatients()" type="button" variant="primary" size="lg"
              class="w-100" :disabled="false">Charger Plus</b-button>
            <b-button v-else disabled variant="primary" size="lg" class="w-100">
              <div class="span w-100">
                <div class="typing_loader"></div>
              </div>
            </b-button>
          </b-colxx>
        </b-row>
        <b-card class="w-100" v-if="!filtredPatients.length" no-body>
          <b-card-body class="text-center p-4">
            <h5 class="card-title mb-0">Aucun patient trouvé.</h5>
          </b-card-body>
        </b-card>
      </template>
      <template v-else>
        <div class="loading"></div>
      </template>
    </b-colxx>
  </b-row>
</template>
<script>
import "vue-select/dist/vue-select.css";
import Vue from "vue";
import "bootstrap";
import bootbox from "bootbox";
import DataListItem from "@/components/Listing/PatientListItem";
import { apiUrl } from "@/constants/config";
export default {
  name: "patients",
  components: {
    DataListItem,
  },
  data() {
    return {
      isLoad: false,
      apiBase: apiUrl,
      currentPatient: null,
      isEdit: false,
      displayMode: "thumb",
      listPatients: [],
      newUser: {
        name: "",
        cin: "",
        email: "",
        phone: "",
        mituel: "",
        adresse: "",
        gender: "",
        birthdate: "",
        profession: "",
        situation: "",
        rabais: "",
        antecedents: "",
        allergie: "",
      },
      searchText: "",
      patientsPage: null,
      loadingMore: false,
    };
  },
  methods: {
    isValidPatient() {
      const schema = this.$joi.object({
        name: this.$joi.string().min(3),
        cin: this.$joi.string().alphanum().min(3),
        email: this.$joi
          .string()
          .email({
            minDomainSegments: 2,
            tlds: { allow: ["com", "net", "fr", "ma"] },
          }),
        phone: this.$joi.string().alphanum().min(8),
        adresse: this.$joi.string().min(5),
        gender: this.$joi.string().min(3),
      });
      let name = schema.validate({ name: this.newUser.name });
      let cin = schema.validate({ cin: this.newUser.cin });
      let email = schema.validate({ email: this.newUser.email });
      let phone = schema.validate({ phone: this.newUser.phone });
      let adresse = schema.validate({ adresse: this.newUser.adresse });
      let gender = schema.validate({ gender: this.newUser.gender });
      if (name.error) {
        this.$notify("error filled", "", "Le format du nom est invalide.", {
          duration: 5000,
          permanent: false,
        });
        return false;
      } else if (cin.error) {
        this.$notify("error filled", "", "Le format du cin est invalide.", {
          duration: 5000,
          permanent: false,
        });
        return false;
      } else if (phone.error) {
        this.$notify(
          "error filled",
          "",
          "Le format du Numéro de Téléphone est invalide.",
          { duration: 5000, permanent: false }
        );
        return false;
      } else if (adresse.error) {
        this.$notify(
          "error filled",
          "",
          "Le format d'Adresse postale est invalide.",
          { duration: 5000, permanent: false }
        );
        return false;
      } else if (gender.error) {
        this.$notify(
          "error filled",
          "",
          "Genre non selectionné! , Merci de selectionner un genre.",
          { duration: 5000, permanent: false }
        );
        return false;
      } else {
        if (this.newUser.email == "") {
          return true;
        } else {
          if (email.error) {
            this.$notify(
              "error filled",
              "",
              "Le format d'email est invalide.",
              { duration: 5000, permanent: false }
            );
            return false;
          } else {
            return true;
          }
        }
      }
      console.log("name", name);
      console.log("cin", cin);
      console.log("email", email);
      // return false
    },
    addItem() {
      this.currentPatient = null;
      this.newUser = {
        name: "",
        cin: "",
        email: "",
        phone: "",
        mituel: "",
        adresse: "",
        gender: "",
        birthdate: "",
        profession: "",
        situation: "",
        rabais: "",
        antecedents: "",
        allergie: "",
      };
      this.isEdit = false;
    },
    getMorePatients() {
      this.loadingMore = true;
      let page = this.patientsPage;
      this.sendRequest("get", this.currentEndpoint + "/page/" + page)
        .then((res) => {
          console.log("reees", res);
          this.listPatients = [...this.listPatients, ...res.data.data];
          this.patientsPage = res.data.next;
          this.loadingMore = false;
        })
        .catch((err) => {
          this.loadingMore = false;
          console.log("iam the error", err);
        });
    },
    getPatients() {
      this.isLoad = false;
      let page = this.patientsPage ? this.patientsPage : 1;
      this.sendRequest("get", this.currentEndpoint + "/page/" + page)
        .then((res) => {
          console.log("reees", res);
          this.listPatients = res.data.data;
          this.patientsPage = res.data.next;
          this.isLoad = true;
        })
        .catch((err) => {
          this.isLoad = true;
          console.log("iam the error", err);
        });
    },
    hideModal(refname) {
      this.$refs[refname].hide();
      this.currentPatient = null;
      this.newUser = {
        name: "",
        cin: "",
        email: "",
        phone: "",
        mituel: "",
        adresse: "",
        gender: "",
        birthdate: "",
        profession: "",
        situation: "",
        rabais: "",
        antecedents: "",
        allergie: "",
      };
      this.isEdit = false;
    },
    changeDisplayMode(displayType) {
      this.displayMode = displayType;
    },
    addNewItem() {
      if (this.isValidPatient()) {
        let obj = {
          name: this.newUser.name,
          cin: this.newUser.cin,
          email: this.newUser.email,
          phone: this.newUser.phone,
          mituel: this.newUser.mituel,
          adresse: this.newUser.adresse,
          gender: this.newUser.gender,
          birthdate: this.newUser.birthdate,
          profession: this.newUser.profession,
          situation: this.newUser.situation,
          rabais: this.newUser.rabais,
          antecedents: this.newUser.antecedents,
          allergie: this.newUser.allergie,
        };
        if (this.isEdit) {
          this.sendRequest(
            "put",
            this.currentEndpoint + `/id/${this.currentPatient.id}`,
            obj
          )
            .then((res) => {
              if (res.status == 200) {
                let idx = this.listPatients.findIndex(
                  (ob) => ob.id == this.currentPatient.id
                );
                if (idx !== -1) {
                  (this.listPatients[idx].name = this.newUser.name),
                    (this.listPatients[idx].cin = this.newUser.cin),
                    (this.listPatients[idx].email = this.newUser.email),
                    (this.listPatients[idx].phone = this.newUser.phone),
                    (this.listPatients[idx].mituel = this.newUser.mituel);
                  this.listPatients[idx].adresse = this.newUser.adresse;
                  this.listPatients[idx].gender = this.newUser.gender;
                  this.listPatients[idx].birthdate = this.newUser.birthdate;
                  this.listPatients[idx].profession = this.newUser.profession;
                  this.listPatients[idx].situation = this.newUser.situation;
                  this.listPatients[idx].rabais = this.newUser.rabais;
                  this.listPatients[idx].antecedents = this.newUser.antecedents;
                  this.listPatients[idx].allergie = this.newUser.allergie;
                }
                this.hideModal("modalright");
              }
            })
            .catch((err) => {
              this.isLoad = true;
            });
        } else {
          this.sendRequest("post", this.currentEndpoint, obj)
            .then((res) => {
              if (res.status == 200) {
                this.listPatients.push(res.data);
                this.hideModal("modalright");
              }
            })
            .catch((err) => {
              this.isLoad = true;
            });
        }
      }
    },
    editPatient(event, id) {
      let index = this.listPatients.findIndex((obj) => obj.id == id);
      let item = this.listPatients[index];
      this.currentPatient = item;
      this.isEdit = event;
      this.newUser.name = item.name;
      this.newUser.cin = item.cin;
      this.newUser.email = item.email;
      this.newUser.phone = item.phone;
      this.newUser.mituel = item.mituel;
      this.newUser.adresse = item.adresse;
      this.newUser.gender = item.gender;
      this.newUser.birthdate = item.birthdate;
      this.newUser.profession = item.profession;
      this.newUser.situation = item.situation;
      this.newUser.rabais = item.rabais;
      this.newUser.antecedents = item.antecedents;
      this.newUser.allergie = item.allergie;
      this.$refs.modalright.show();
    },
    deletePatient(event, id) {
      let index = this.listPatients.findIndex((obj) => obj.id == id);
      let item = this.listPatients[index];
      bootbox.confirm({
        message: "Etes vous Sur ?",
        locale: "fr",
        callback: (result) => {
          if (result) {
            this.deleteCurrentPatient(item.id, index);
          }
        },
      });
    },
    deleteCurrentPatient(id, index) {
      this.sendRequest("delete", this.currentEndpoint + `/id/${id}`)
        .then((res) => {
          if (res.status == 200) {
            this.listPatients.splice(index);
          }
        })
        .catch((err) => {
          this.isLoad = true;
        });
    },
  },
  computed: {
    currentEndpoint() {
      return `${this.apiBase}/patients`;
    },
    filtredPatients() {
      if (!this.listPatients.length) {
        return [];
      }
      return this.listPatients.filter((res) => {
        return (
          res.email.toLowerCase().includes(this.searchText.toLowerCase()) ||
          res.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
          res.phone.toLowerCase().includes(this.searchText.toLowerCase()) ||
          res.cin.toLowerCase().includes(this.searchText.toLowerCase())
        );
      });
    },
  },
  watch: {
    currentEndpoint() {
      this.getPatients();
    },
  },
  mounted() {
    this.getPatients();
  },
};
</script>
<style lang="scss">
.bootbox {
  .modal-dialog {
    .modal-content {
      .modal-footer {
        padding: 15px;
      }
    }
  }
}

.typing_loader {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  -webkit-animation: typing 1s linear infinite alternate;
  -moz-animation: Typing 1s linear infinite alternate;
  animation: typing 1s linear infinite alternate;
  margin: 10px auto;
  /* Not necessary- its only for layouting*/
  position: relative;
  left: -12px;
}

@-webkit-keyframes typing {
  0% {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  25% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  75% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 1);
  }
}

@-moz-keyframes typing {
  0% {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  25% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  75% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 1);
  }
}

@keyframes typing {
  0% {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  25% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 2),
      24px 0px 0px 0px rgba(255, 255, 255, 0.2);
  }

  75% {
    background-color: rgba(255, 255, 255, 0.4);
    box-shadow: 12px 0px 0px 0px rgba(255, 255, 255, 0.2),
      24px 0px 0px 0px rgba(255, 255, 255, 1);
  }
}
</style>
